/// <amd-module name="Search/Shared/Components/ZeroData/ZeroData" />
import * as React from "react";
import { IZeroDataProps, ScenarioType } from "./ZeroData.Props";
import { getAssetLocation } from "VSS/Platform/Location";
import { IVssPageContext } from "VSS/Platform/Context";

export class ZeroData extends React.PureComponent<IZeroDataProps> {
    public render(): JSX.Element {
        const imgSrcUrl = getImgSrcUrl(this.props.pageContext, this.props.scenario);
        return (
            <div className="search-ZeroData--container v-scroll-auto">
                <div className="zero-data flex-column flex-grow">
                    {
                        imgSrcUrl &&
                        <img className="icon" src={imgSrcUrl} alt="" />
                    }
                    <div className="message">{this.props.message}</div>
                    <div className="suggestion">{this.props.help}</div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        if (this.props.onDidMount) {
            this.props.onDidMount();
        }
    }
}

function getImgSrcUrl(pageContext: IVssPageContext, scenario: ScenarioType): string {
    let imagePath: string = "";
    if (scenario === ScenarioType.ZeroResults ||
        scenario === ScenarioType.PrefixWildCardNotSupported ||
        scenario === ScenarioType.EmptyQueryNotSupported ||
        scenario === ScenarioType.OnlyWildcardQueryNotSupported ||
        scenario === ScenarioType.ZeroResultsWithWildcard ||
        scenario === ScenarioType.ZeroResultsWithFilter ||
        scenario === ScenarioType.ZeroResultsWithWildcardAndFilter ||
        scenario === ScenarioType.ZeroResultsWithNoWildcardNoFilter ||
        scenario === ScenarioType.WildcardQueriesWithCEFacetsNotSupported ||
        scenario === ScenarioType.PhraseQueriesWithCEFacetsNotSupported ||
        scenario === ScenarioType.UnsupportedProximitySearchTerm || 
        scenario === ScenarioType.CEFFacetSubstring ||
        scenario === ScenarioType.CEFFacetSubstringWithInfixWildcard || 
        scenario === ScenarioType.SubStringTooShort ||
        scenario === ScenarioType.SubStringWithInfixWildcard ||
        scenario === ScenarioType.QuestionMarkWildcardSubstring) {
        imagePath = getAssetLocation(pageContext, "ms.vss-search-web/search-shared/Images/NoResults.svg");
    }

    if (scenario === ScenarioType.NoPermission ||
        scenario === ScenarioType.NoPermissionAfterShowMore ||
        scenario === ScenarioType.NoPermissionWithShowMore) {
        imagePath = getAssetLocation(pageContext, "ms.vss-search-web/search-shared/Images/NoPermission.svg");
    }

    if (scenario === ScenarioType.ServiceError ||
        scenario === ScenarioType.IndexingScenario) {
        imagePath = getAssetLocation(pageContext, "ms.vss-search-web/search-shared/Images/ServiceError.svg");
    }

    return imagePath;
}
